








import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { UserInfo } from '@/store/pages/login/index.d';
import Auth from '../../mixins/auth.mixin';
const Login = namespace('login');

@Component
export default class Logins extends Auth {
  @Login.Getter('userInfo') private userInfo!: UserInfo;
  @Login.Action('restUserInfo') private restUserInfo: any;
  @Login.Action('getLoginUrl') private getLoginUrl: any;

  public mounted() {
    this.restUserInfo();
  }

  public handleGoLogin() {
    const origin = window.location.origin;
    const next = `${origin}/index`;
    const fail = `${origin}/login`;
    this.getLoginUrl({next, fail}).then((res: any) => {
      window.location.href = res;
    });
  }
}
